import dayjs from 'dayjs';
import 'dayjs/locale/en-in';
import badMutable from 'dayjs/plugin/badMutable';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import duration from 'dayjs/plugin/duration';
import localData from 'dayjs/plugin/localeData';
import arraySupport from 'dayjs/plugin/arraySupport';
import isoWeek from 'dayjs/plugin/isoWeek';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.locale('en-in');
dayjs.extend(badMutable); //not good but have to be done to make the existing code compatible with moment
dayjs.extend(advancedFormat);
dayjs.extend(duration);
dayjs.extend(localData);
dayjs.extend(arraySupport);
dayjs.extend(isoWeek);
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);

dayjs.extend(utc)
dayjs.extend(timezone)

export default dayjs;
